import * as fromDatatype from '../datatype-library/index';
import * as fromDataype from "../datatype-library";

export interface app_generic_resource_line_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  hdr_guid: fromDatatype.GuidDataFieldInterface;
  txn_type: fromDatatype.VarcharDatatypeInterface;
  logic: fromDatatype.VarcharDatatypeInterface;
  code: fromDatatype.VarcharDatatypeInterface;
  name: fromDataype.VarcharDatatypeInterface;
  descr: fromDatatype.TextDatatypeInterface;
  uom: fromDatatype.VarcharDatatypeInterface;
  amount: fromDatatype.MoneyDatatypeInterface;
  property_json: fromDatatype.JsonDatatypeInterface;
  options_json: fromDatatype.JsonDatatypeInterface;
  log_json: fromDatatype.JsonDatatypeInterface;
  status: fromDatatype.StatusDataFieldInterface;
  revision: fromDatatype.RevisionDataFieldInterface;
  vrsn: fromDatatype.VrsnDataFieldInterface;
}

export class app_generic_resource_line_RowClass implements app_generic_resource_line_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  hdr_guid: fromDatatype.GuidDataFieldInterface;
  txn_type: fromDatatype.VarcharDatatypeInterface;
  logic: fromDatatype.VarcharDatatypeInterface;
  code: fromDatatype.VarcharDatatypeInterface;
  name: fromDataype.VarcharDatatypeInterface;
  descr: fromDatatype.TextDatatypeInterface;
  uom: fromDatatype.VarcharDatatypeInterface;
  amount: fromDatatype.MoneyDatatypeInterface;
  property_json: fromDatatype.JsonDatatypeInterface;
  options_json: fromDatatype.JsonDatatypeInterface;
  log_json: fromDatatype.JsonDatatypeInterface;
  status: fromDatatype.StatusDataFieldInterface;
  revision: fromDatatype.RevisionDataFieldInterface;
  vrsn: fromDatatype.VrsnDataFieldInterface;
}


